module.exports = __webpack_public_path__ + "242d9e8a1b00f54b8b246bd88e6f283a.MP3";